import { Injectable } from '@angular/core';

@Injectable()
export class InvoiceUrl {
    public static get GET_SEARCH_TYPE(): string { return '/api/Invoice/SearchType'; }
    public static get GET_USERINFOR(): string { return '/api/Invoice/UserInfo'; }
    public static get GET_CURRENCY_ACCOUNTPAYMENT(): string { return '/api/Invoice/currency'; }
    public static get GET_LIST_INVOICE(): string { return '/api/Invoice'; }
    public static get GET_INVOICE(): string { return '/api/Invoice/{0}'; }
    public static get GET_LIST_CREDIT(): string { return '/api/Invoice/Credit'; }
    public static get GET_CONSULTATION_CASH_SALE(): string { return '/api/Invoice/cashSale/{0}'; }
    public static get GET_CASH_SALE(): string { return '/api/Invoice/cashSale'; }
    public static get CONSULTATION_INVOICE(): string { return '/api/Invoice/consultationInvoice/{0}'; }
    public static get ADD_INVOICE_PRODUCT(): string { return '/api/invoice/cashSale/{0}/addProduct'; }
    public static get ADD_CASH_SALE_PRODUCT(): string { return '/api/invoice/cashSale/addProduct'; }
    public static get ADD_ACCOUNTPAYMENT_CREDITNOTE(): string { return '/api/invoice/{0}/AccountPaymentCreditNote' }
    public static get ALLOCATE_CREDITNOTE(): string { return '/api/invoice/{0}/AccountPaymentCreditNote/{1}' }
    public static get ADD_ORDER_NUMBER_INVOICE(): string { return '/api/invoice/OrderNumber'; }
    public static get UPDATE_INVOICE_BADDEBT(): string { return '/api/invoice/{0}/UpdateBadDebt'; }
    public static get GET_ACCOUNT_PAYMENT_METHOD(): string { return '/api/invoice/AccountPaymentMethod'; }
    public static get PAY_INVOICE(): string { return '/api/invoice/Pay'; }
    public static get REFUND_INVOICE(): string { return '/api/invoice/{0}/refund'; }
    public static get UPDATE_WITHHOLDING_TAX(): string { return '/api/invoice/{0}/witholdingtax'; }
    public static get RECEIVED_TAX(): string { return '/api/invoice/ReceivedWitholdingTax'; }
    public static get GET_ALL_ORGANIZATION(): string { return '/api/invoice/Organization'; }
    public static get GET_CENTRE_ACCOUNT_PAYMENT(): string { return '/api/invoice/Centre'; }
    public static get GET_CENTRE_GROUP(): string { return '/api/invoice/CentreGroup'; }
    public static get GET_ACCONT_PAYMENT_INVOICE_CASH_SALE(): string { return '/api/invoice/CashSaleAccountPayment/{0}'; }
    public static get UPDATE_ACCONT_PAYMENT_INVOICE_INFORMATION(): string { return '/api/invoice/SaveInvoiceInfo'; }
    public static get GET_ACCONT_PAYMENT_INVOICE_PAYMETHOD(): string { return '/api/invoice/{0}/Paymethod'; }
    public static get UPDATE_ACCONT_PAYMENT_INVOICE_PAYMETHOD(): string { return '/api/invoice/Paymethod'; }

    public static get ADD_INVOICE_CREDIT_NOTE(): string { return '/api/invoice/cashSale/{0}/addCreditNote'; }
    public static get ADD_CASH_SALE_CREDIT_NOTE(): string { return '/api/invoice/cashSale/addCreditNote'; }

    public static get ADD_INVOICE_ITEM(): string { return '/api/invoice/{1}/cashSale/{0}/addInvoiceItems'; }

    public static get UPDATE_INVOICE_INFORMATION(): string { return '/api/invoice/cashSale/{0}/savevInvoiceInfo'; }
    public static get GET_INVOICE_PAYMENT_METHOD(): string { return '/api/invoice/paymentMethod'; }

    public static get UPDATE_CONSULTATION_INVOICE(): string { return '/api/invoice/cashSale/{0}'; }

    public static get ADD_NOTE_TO_INVOICE(): string { return '/api/invoice/addInvoiceNote'; }

    public static get GET_INVOICE_ITEM(): string { return '/api/invoice/{0}/items/{1}'; }

    public static get EMAIL_INVOICE(): string { return '/api/Invoice/emailInvoice'; }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/invoice.url.ts